import { cva, VariantProps } from 'class-variance-authority'
import { cn } from '~/lib/utils'
import {
  Avatar as AvatarWrapper,
  AvatarFallback,
  AvatarImage
} from '~/components/UI/shadcn/avatar'
import Placeholder from './icon/placeholder'

export type AvatarProps = {
  avatar: {
    type: 'image' | 'initials' | 'placeholder'
    initials?: string
    image?: Image
  }
  colour: VariantProps<typeof avatarVariants>['colour']
}

const avatarVariants = cva('', {
  variants: {
    colour: {
      'ink-blue': 'bg-blue-d text-white',
      'mid-blue': 'bg-blue-m text-white',
      'light-blue': 'bg-blue-l text-blue-d',
      white: 'bg-white text-blue-d'
    }
  },
  defaultVariants: {
    colour: 'ink-blue'
  }
})

const Avatar = ({ avatar, colour }: AvatarProps) => {
  const { type, image, initials } = avatar

  const previewUrl =
    'https://preview-websitemodern-uni-hull.cloud.contensis.com'

  return (
    <AvatarWrapper className='lg:h-l lg:w-l h-[44px] w-[44px] shrink-0'>
      {type === 'image' && image && (
        <AvatarImage
          src={`${previewUrl}${image?.asset.sys.uri}${image?.asset.sys.uri.includes('?') ? '&' : '?'}w=48&h=48&fit=crop&f=webp`}
          alt={image?.altText}
        />
      )}
      {type === 'initials' && initials && (
        <AvatarFallback className={cn(avatarVariants({ colour }))}>
          {initials.toUpperCase()}
        </AvatarFallback>
      )}
      {(type === 'placeholder' || (!image && !initials)) && (
        <AvatarFallback className={cn(avatarVariants({ colour }), 'p-2xs')}>
          <Placeholder />
        </AvatarFallback>
      )}
    </AvatarWrapper>
  )
}

export default Avatar
